import React, { useState, useEffect } from 'react';
import { apiPut } from '../../utils/apiUtils';
import { API_URLS } from '../../config/api';
import './InteractiveSceneStartMessage.css';
import CustomSelect from '../CustomSelect';

// The start message opens the AI dialogue and sets the tone the model keeps copying; empty is allowed
const START_MESSAGE_MIN = 225;
const START_MESSAGE_MAX = 800;

const InteractiveSceneStartMessage = ({ novelId, sceneId, scene, setScene, novel, setNovel, setLoading, setError, isProduction = false, sceneType = 'interactive' }) => {
  const [startMessage, setStartMessage] = useState(scene.start_message_original || '');
  const [speakerId, setSpeakerId] = useState(scene.start_message_speaker_id || (novel?.characters?.length > 0 ? novel.characters[0].id : ''));

  useEffect(() => {
    setStartMessage(scene.start_message_original || '');
    setSpeakerId(scene.start_message_speaker_id || (novel?.characters?.length > 0 ? novel.characters[0].id : ''));
  }, [scene, novel]);

  // The range only applies to scenes where the AI dialogue follows the start message
  const length = startMessage.trim().length;
  const rangeApplies = scene?.interactive !== false;
  const lengthInvalid = rangeApplies && length > 0 && (length < START_MESSAGE_MIN || length > START_MESSAGE_MAX);

  const handleSaveChanges = async () => {
    if (lengthInvalid) {
      setError(`Стартовое сообщение должно быть от ${START_MESSAGE_MIN} до ${START_MESSAGE_MAX} символов (сейчас ${length})`);
      return;
    }
    try {
      setLoading(true);
      setError(null);

      const updatedScenePayload = {
        ...scene,
        start_message_original: startMessage,
        start_message_speaker_id: speakerId || null,
      };

      const getStartMsgUrl = () => {
        if (sceneType === 'open_world') return isProduction ? API_URLS.PRODUCTION_OPEN_WORLD_SCENE(novelId, sceneId) : API_URLS.BUILDING_OPEN_WORLD_SCENE(novelId, sceneId);
        return isProduction ? API_URLS.PRODUCTION_INTERACTIVE_SCENE(novelId, sceneId) : `${API_URLS.BUILDING_NOVELS}/${novelId}/interactive_scene/${sceneId}`;
      };
      const response = await apiPut(
        getStartMsgUrl(),
        updatedScenePayload,
        {},
        true,
        'Стартовое сообщение успешно обновлено!'
      );

      const updatedNovel = response.data;
      if (setNovel) {
        setNovel(updatedNovel);
      }

      const keyMap = { interactive: 'interactive_scenes', open_world: 'open_world_interactive_scenes' };
      const key = keyMap[sceneType] || 'interactive_scenes';
      const updatedScene = updatedNovel[key]?.find(s => s.id === sceneId);
      if (updatedScene) {
        setScene(updatedScene);
      }
    } catch (err) {
      setError(err.message || 'Не удалось обновить стартовое сообщение');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="issm-wrap">
      <h4 className="issm-title">Стартовое сообщение</h4>
      <div className="issm-form-group">
        <label className="issm-label" htmlFor="start-message">Сообщение</label>
        <textarea
          id="start-message"
          className="issm-textarea"
          rows="4"
          placeholder="Введите сообщение, которое будет отображаться в начале сцены..."
          value={startMessage}
          onChange={(e) => setStartMessage(e.target.value)}
        />
        <div className={`issm-counter${lengthInvalid ? ' issm-counter-invalid' : ''}`}>
          Символов: {length}
          {rangeApplies && ` · допустимо от ${START_MESSAGE_MIN} до ${START_MESSAGE_MAX}`}
        </div>
      </div>
      <div className="issm-form-group">
        <label className="issm-label" htmlFor="speaker-select">Говорящий</label>
        <CustomSelect
          id="speaker-select"
          className="app-select"
          value={speakerId}
          onChange={(e) => setSpeakerId(e.target.value)}
        >
          {novel?.characters?.map((character) => (
            <option key={character.id} value={character.id}>
              {character.prompt_name}
            </option>
          ))}
        </CustomSelect>
      </div>
      <button className="issm-btn-primary" onClick={handleSaveChanges}>
        Сохранить изменения
      </button>
    </div>
  );
};

export default InteractiveSceneStartMessage;
